function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import PropTypes from '../../../_snowpack/pkg/prop-types.js';
import S from '../../../_snowpack/pkg/react-switch.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import { colors } from '../colors.js';
import IconCheck from '../../icons/check.js';
const CheckedCmp = styled.span.withConfig({
  displayName: "switch__CheckedCmp",
  componentId: "t4p33m-0"
})(["height:20px;display:flex;align-items:center;justify-content:center;"]);
const ReactSwitch = S.default;
const checkedIcon = /*#__PURE__*/React.createElement(CheckedCmp, null, /*#__PURE__*/React.createElement(IconCheck, {
  color: "#fff",
  size: "15px"
}));
const Label = styled.label.withConfig({
  displayName: "switch__Label",
  componentId: "t4p33m-1"
})(["margin-left:", "px;margin-right:", "px;font-size:0.85rem;"], props => props.right ? 15 : 0, props => props.left ? 15 : 0);
const Wrapper = styled.div.withConfig({
  displayName: "switch__Wrapper",
  componentId: "t4p33m-2"
})(["display:flex;align-items:center;"]);
export const Switch = ({
  id,
  label,
  labelPosition,
  ...rest
}) => /*#__PURE__*/React.createElement(Wrapper, null, label && labelPosition === 'left' && /*#__PURE__*/React.createElement(Label, {
  left: true,
  htmlFor: id
}, label), /*#__PURE__*/React.createElement(ReactSwitch, _extends({
  id: id,
  onColor: colors.glacier,
  handleDiameter: 20,
  height: 20,
  width: 48,
  checkedIcon: checkedIcon,
  uncheckedIcon: false,
  boxShadow: "0 0 12px rgba(0, 0, 0, .3)"
}, rest)), label && labelPosition !== 'left' && /*#__PURE__*/React.createElement(Label, {
  right: true,
  htmlFor: id
}, label));
Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(['left', 'right']),
  onChange: PropTypes.func.isRequired
};